<template>
  <div class="class-item">
    <div class="first">
      <div class="text" style="color: #333;">一级分类</div>
      <el-input
        size="medium"
        placeholder="请输入分类"
        v-model="data.category_name"
      ></el-input>
      <div class="icon-btn">
        <img src="./img/fill.svg" class="item-btn" @click="handleAdd"/>
        <img src="./img/7.Icon／suggested／6.minus-circle／fill.svg" class="item-btn" @click="handleRemoveAll"/>
        <img src="./img/Path.svg" class="item-btn" @click="handleMoveTop"/>
        <img src="./img/Path备份.svg" class="item-btn" @click="handleMoveDown"/>
      </div>
    </div>

    <div class="chidren">
      <div class="chidren-item" v-for="(item, index) in data.children" :key="item._id">
        <div class="text" style="color: #666;">二级分类</div>
        <el-input
          size="medium"
          placeholder="请输入分类"
          v-model="item.category_name"
        ></el-input>
        <img src="./img/7.Icon／suggested／6.minus-circle／fill.svg" class="remove-btn item-btn" @click="handleRemove(index)"/>
      </div>
    </div>

    <div class="footer-btn" @click="hanldeAddClass"><img class="footer-icon" src="./img/plus-circle.svg"/>增加二级分类</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      require: true
    }
  },
  methods: {
    handleAdd() {
      this.$emit("add");
    },
    handleMoveDown() {
      this.$emit("movedown");
    },
    handleMoveTop() {
      this.$emit("movetop");
    },
    handleRemoveAll() {
      this.$emit("remove");
    },
    handleRemove(index) {
      const children = this.data.children;
      if(children.length < 2) return
      children.splice(index, 1);
    },
    hanldeAddClass() {
      const children = this.data.children;
      children.push({
        _id: new Date().getTime(),
        category_name: ""
      });
    }
  }
};
</script>

<style scoped>
.footer-icon{
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.footer-btn{
  display: flex;
  justify-content: right;
  align-items: center;
  font-size: 12px;
  color: #3E89FF;
  margin-top: 14px;
  margin-right: 20px;
  cursor: pointer;
}
.class-item{
  padding: 16px 0;
  border-bottom: 1px solid #F3F5F7;
}
.first,
.chidren-item {
  display: flex;
  align-items: center;
}
.text {
  flex-shrink: 0;
  margin-right: 5px;
}
.icon-btn {
  display: flex;
  flex-shrink: 0;
  margin-left: 5px;
}
.item-btn{
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.item-btn+.item-btn{
  margin-left: 8px
}
.chidren {
  margin-top: 14px;
  margin-left: 72px;
}
.chidren-item + .chidren-item {
  margin-top: 14px;
}
.remove-btn {
  margin-left: 5px;
}

</style>
